export class Checksum {
  public static compute(data: Uint8Array): number {
    let computedChecksum: number = 0;
    for (let i = 0; i < data.length; i++) {
      computedChecksum = computedChecksum + data[i];
    }
    return computedChecksum;
  }
}
